import { render, staticRenderFns } from "./userReturnManagement.vue?vue&type=template&id=87d373f4&scoped=true&"
import script from "./userReturnManagement.vue?vue&type=script&lang=ts&"
export * from "./userReturnManagement.vue?vue&type=script&lang=ts&"
import style0 from "./userReturnManagement.vue?vue&type=style&index=0&id=87d373f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d373f4",
  null
  
)

export default component.exports